<template lang="html">
  <div>
    <vx-tooltip
      :delay="tooltipDelay"
      :text="tooltipText"
      :tooltipPosition="tooltipPosition"
    >
      <feather-icon
        icon="SendIcon"
        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
        @click="open"
      />
    </vx-tooltip>
    <vs-popup :title="popupTitle" :active.sync="active">
      <div>
        <vs-row class="mt-2">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            class="font-semibold text-primary"
          >
            <p>
              {{ $t('are_you_sure') }}
              {{ $t('once_the_email_is_sent_you_can_not_undo_this_action') }}.
              <br />
              {{ $t('type_the_following_code_to_continue') }} :
              {{ randomNumber }}
            </p>
          </vs-col>
        </vs-row>
        <vs-row class="mt-2">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-input v-model="code" placeholder="Code"></vs-input>
          </vs-col>
        </vs-row>
        <vs-row
          vs-align="center"
          vs-type="flex"
          vs-justify="center"
          class="mt-5"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
              :disabled="(!disabledButton || loading)"
              color="primary"
              type="filled"
              class="w-full"
              @click.prevent="submit"
              >{{ $t('submit') }}</vs-button
            >
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="6"
            class="mt-2 px-2"
          >
            <vs-button
              color="primary"
              type="border"
              class="w-full"
              @click="close"
              >{{ $t('cancel') }}</vs-button
            >
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import invoice from '@/http/requests/invoice'
export default {
  props: {
    btnColor: {
      type: String,
      default: 'primary'
    },
    btnType: {
      type: String,
      default: 'border'
    },
    btnIcon: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: 'button'
    },
    popupTitle: {
      type: String,
      default: 'title'
    },
    tooltipDelay: {
      type: String,
      default: '1.5s'
    },
    tooltipPosition: {
      type: String,
      default: 'top'
    },
    tooltipText: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      active: false,
      randomNumber: 0,
      code: '',
      loading:false
    }
  },
  computed: {
    disabledButton() {
      return this.code === this.randomNumber.toString()
    }
  },
  methods: {
    open() {
      this.active = true
      this.randomNumber = this.getRandomNumber(1000, 9999)
      this.code = ''
    },
    close() {
      this.active = false
    },
    getRandomNumber(min, max) {
      return Math.round(Math.random() * (max - min) + min)
    },
    submit() {
      this.loading = true
      invoice
        .resendEmailInvoice(this.data.InvoiceId)
        .then(res => {
          this.close()
          this.$vs.notify({
            color: 'success',
            title: 'Action',
            text: 'Invoice Sent'
          })
          this.loading = false
        })
        .catch(err => {
          if (422 === err.response.status) {
            this.$vs.notify({
              color: 'danger',
              title: 'Attention',
              text: err.response.data.msg
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Attention',
              text: 'SERVER ERROR'
            })
          }
          this.loading = false
        })
    }
  }
}
</script>
